import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs";

@Injectable()
export class BidCycleService {
    private _data: BehaviorSubject<number> = new BehaviorSubject(null);
  
    public get Data(): Observable<number>{
      return this._data.asObservable();
    }
    constructor() { 
    }
  
    setExpiryTime(expTime: number){
      this._data.next(expTime);
    }
  }